import cn from 'classnames';
export default function SelectOption({
  handleOptionBlur,
  handleOptionKeyDown,
  handleSelectOption,
  id,
  idx,
  option,
  optionsRef,
  selectedItem,
  className,
  ...rest
}) {
  if (option.value === undefined) {
    const idStr = option.label.replaceAll(' ', '-');
    return (
      <div
        className={cn(
          'select-group-label',
          className
        )}
        ref={optionsRef.current[idx]}
        tabIndex="-1"
        id={`${id}-group-label-${idStr}`}
        aria-hidden="true"
        {...rest}
      >
        {option.label}
      </div>
    );
  }

  const groupId = option.group ? option.group.replaceAll(' ', '-') : null;
  const describedBy = groupId ? `${id}-group-label-${groupId}` : null;

  return (
    <button
      id={`${id}-option-btn-${idx}`}
      role="option"
      type="button"
      ref={optionsRef.current[idx]}
      tabIndex="-1"
      // In Safari non-text input elements do not gain focus on click.
      // Here we prevent the default mousedown behavior, which allows
      // the button element to gain focus
      onMouseDown={(event) => event.preventDefault()}
      onClick={() => handleSelectOption(option, `${id}-option-btn-${idx}`)}
      onBlur={handleOptionBlur}
      onKeyDown={handleOptionKeyDown}
      data-option={`${id}-option-btn-${option.value}`}
      aria-describedby={describedBy}
      className={cn(
        'lds-button-clear-style',
        'lds-select-option',
        {
          selected: selectedItem.value === option.value,
          grouped: option.group,
        },
        className
      )}
      {...rest}
    >
      {option.label}
    </button>
  );
}
